import React from 'react';



const Footer = () => {
    return (
        <footer className="bg-dark text-center text-white mt-5">
        <div className="container p-4">
          <section className="mb-4">
            <h2>Tutor Academy</h2>
            <p>Explore your skills with us and get your dream skill job.</p>
          </section>
        </div>

        <div
          className="text-center p-3"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.2" }}
        >
          © 2022 Copyright: All right riserved
          <p className="text-info">Tutor Academy</p>
        </div>
      </footer>
    );
};

export default Footer;